import { render, staticRenderFns } from "./ConversationAvatar.vue?vue&type=template&id=012a7bce&scoped=true"
import script from "./ConversationAvatar.vue?vue&type=script&lang=js"
export * from "./ConversationAvatar.vue?vue&type=script&lang=js"
import style0 from "./ConversationAvatar.vue?vue&type=style&index=0&id=012a7bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012a7bce",
  null
  
)

export default component.exports